/**
 * Region trait module (ADR-149).
 * Owner context: @sharpee/world-model — traits / spatial
 */
export { RegionTrait, IRegionData } from './regionTrait.js';
